import {Component, EventEmitter, Input, OnChanges, Output, ViewChild} from '@angular/core';
import {NgbDropdown} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dropdown-with-input',
  templateUrl: './dropdown-with-input.component.html',
  styleUrls: ['./dropdown-with-input.component.scss']
})
export class DropdownWithInputComponent implements OnChanges {
  @Input() options: string[];
  @Output() selectOption: EventEmitter<string> = new EventEmitter<string>();
  @Input() hasError: boolean;
  @Input() submitted: boolean;
  @Input() disabled?: boolean = false;
  @Input() title: string;
  @Input() selectedOption: string | null = null;
  @Input() placeholder: string = 'Vul andere + Enter';
  @Input() mandatoryAsterix = false;

  @ViewChild(NgbDropdown) dropdown: NgbDropdown;
  customInput: string = '';

  ngOnChanges(): void {
    if (this.selectedOption && !this.options.find(opt => opt === this.selectedOption)) {
      this.options.push(this.selectedOption);
    }
  }

  chooseOption(option: string) {
    this.selectedOption = option;
    this.customInput = '';
    this.selectOption.emit(option);
  }

  handleEnter(event: KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.selectedOption = this.customInput.trim();
    this.customInput = '';
    this.selectOption.emit(this.selectedOption);
    this.dropdown.close();
  }

}
